import React from 'react';
import PropTypes from 'prop-types';
import LocaleText from '../../LocaleText';
import Checkbox from '../../Checkbox';
import Isvg from 'react-inlinesvg';

class PrintableInfoPopup extends React.Component {

    render() {
        const classes = ['popup', 'popup--centered', 'printable-info-popup'];
        const { onConfirm, onCancel, onCheckboxChange, isVisible, shouldDisable } = this.props;
        if (!isVisible) {
            return null;
        }
        return (
            <div className={classes.join(' ')}>
                <div className="popup__box">
                    <header className="popup__header">
                        <h3 className="popup__title">
                            <LocaleText textKey="template.print.popup.title"/>
                        </h3>
                        <div className="popup__close" onClick={onCancel}>
                            <Isvg src="/svg/cancel.svg" />
                        </div>
                    </header>
                    <div className="popup__body">
                        <p className="popup__text">
                            <LocaleText textKey="template.print.popup.text"/>
                        </p>
                        <div className="popup__body__inner__grid">
                            <div className="popup__body__inner">
                                <img src="../../../../img/popup-tampondruck.jpg" alt="tampondruck" className="svg-image" />
                                <p className="popup__text">
                                    <LocaleText textKey="template.print.popup.option.first.headline" />
                                </p>
                                <p className="popup__text">
                                    <LocaleText textKey="template.print.popup.option.first.text" />
                                </p>
                            </div>
                            <div className="popup__body__inner">
                                <img src="../../../../img/popup-digitaldruck.jpg" alt="digitaldruck" className="svg-image" />
                                <p className="popup__text">
                                    <LocaleText textKey="template.print.popup.option.second.headline" />
                                </p>
                                <p className="popup__text">
                                    <LocaleText textKey="template.print.popup.option.second.text" />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="buttons">
                        <button className="is-primary" onClick={onConfirm}>
                            <LocaleText textKey="template.print.popup.confirm" />
                        </button>
                    </div>
                    <div>
                        <Checkbox
                            classes={['popup__checkbox']}
                            checked={shouldDisable}
                            name="do-not-show-template-warning-again"
                            type="checkbox"
                            onChange={onCheckboxChange}
                            label={<LocaleText textKey="template.print.popup.label"/>}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

PrintableInfoPopup.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    shouldDisable: PropTypes.bool.isRequired
};

PrintableInfoPopup.defaultProps = {};

export default PrintableInfoPopup;
